import { Component, OnDestroy, OnInit } from '@angular/core';
import { StepImpl } from '../../models/steps/step-impl';
import { OrderingProcessService } from '../../services/ordering-process/ordering-process.service';
import { StepFactoryService } from '../../services/step-factory/step-factory.service';
import { Subscription } from 'rxjs';
import { DummyStep } from '../../models/steps/dummy-step';

@Component({
  selector: 'app-desktop',
  templateUrl: './desktop.component.html',
  styleUrls: ['./desktop.component.scss'],
})
export class DesktopComponent implements OnInit, OnDestroy {
  public steps: StepImpl[] = [];

  private currentStepListener?: Subscription;

  currentStep: StepImpl = new DummyStep();

  constructor(
    private readonly stepFactoryService: StepFactoryService,
    private readonly orderingProcessService: OrderingProcessService
  ) {}

  ngOnInit(): void {
    this.currentStepListener = this.orderingProcessService.$currentStep.subscribe(
      (currentStep) => this.onCurrentStepChanged(currentStep)
    );
    this.steps = this.stepFactoryService.getSteps();
  }

  private onCurrentStepChanged(currentStep: StepImpl): void {
    this.currentStep = currentStep;
  }

  ngOnDestroy(): void {
    this.currentStepListener?.unsubscribe();
  }

  isReady(): boolean {
    return !(this.currentStep instanceof DummyStep);
  }

  hasSteps(): boolean {
    return this.steps.filter((step) => !step.isHidden).length > 0;
  }
}
